import {GuruAllowable} from './guru-allowable';

export class GuruEntity {

  Name!: string;
  Value: any;
  IsValid!: boolean;
  EntityType!: string;
  Description!: string;
  Allowables!: GuruAllowable[];

}
